import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    sizeChartDialog: 'lg:w-228'
  },
  gallery: {
    presets: {
      src: {
        width: 652,
        height: 815
      }
    },
    videoFit: 'cover',
  }
} satisfies RecursivePartial<PdpConfig>
